import { Field, FieldProps } from 'formik';
import React from 'react';
import ToggleButtonOptions, {
	IToggleButtonOptionsProps
} from './ToggleButtonOptions';
import withFormik from './withFormik/withToggleFormik';

interface IFormikToggleButtonOptionsProps {
	name: string;
	options: { value: any; label: string }[];
}

const toggleWithFormik = withFormik(
	(props: IToggleButtonOptionsProps & FieldProps & { name: string }) => (
		<ToggleButtonOptions
			{...props}
			// onChange is necessary because ToggleButtonGroup does not work directly with formik like other mui components
			// For more details - https://stackoverflow.com/questions/62305381/formik-material-ui-not-working-for-toggllebuttongroup-component
			onChange={(_, value) => {
				props.form.setFieldValue(props.name, value);
			}}
		/>
	)
);

const FormikToggleButtonOptions: React.FC<
	IFormikToggleButtonOptionsProps & Partial<IToggleButtonOptionsProps>
> = ({ name, ...rest }) => (
	<Field name={name} component={toggleWithFormik} {...rest} />
);

export default FormikToggleButtonOptions;
